module.exports = __webpack_public_path__ + "static/media/1001120TL.08165fd5.jpg";